import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Button, { ButtonOwnProps } from '@mui/material/Button';

type BasicButtonDetails = {
    label: string;
    onClicK: () => void;
    disabled?: boolean;
};

interface ConfirmationModalProps {
    open: boolean;
    onClose: (value?: string) => void;
    fullWidth?: boolean;
    title: string;
    content: React.ReactElement;
    footer?: {
        primaryButton: BasicButtonDetails;
        secondaryButton?: BasicButtonDetails;
    };
    customFooter?: React.ReactElement;
}

const ConfirmationModal = (props: ConfirmationModalProps): React.ReactElement => {
    const { onClose, open, title, content, customFooter, footer, fullWidth = true } = props;

    const renderActionButton = (buttonDetails: BasicButtonDetails, otherProps?: ButtonOwnProps) => {
        const { label, onClicK, disabled } = buttonDetails;
        return (
            <Button onClick={onClicK} disabled={disabled} size="small" {...otherProps}>
                {label}
            </Button>
        );
    };
    const renderDialogActions = () => {
        if (footer) {
            const { primaryButton, secondaryButton } = footer;
            return (
                <>
                    {footer.secondaryButton && renderActionButton(secondaryButton, { color: 'inherit' })}
                    {renderActionButton(primaryButton)}
                </>
            );
        }

        return customFooter || null;
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth={fullWidth}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>{content}</DialogContent>
            <DialogActions>{renderDialogActions()}</DialogActions>
        </Dialog>
    );
};

export default ConfirmationModal;
